export const CancelSubscriptionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M21.566,17.945a1,1,0,0,0,0-.894l-.516-1.034a1,1,0,0,1,.062-1l.308-.462a1,1,0,0,0,0-1.11L20.79,12.5H12.605l-.631-4.12-1.138.758a2.994,2.994,0,0,0-.888.922l-3.3,5.361a1.989,1.989,0,0,1-1,.821L2.29,17.5v5a1,1,0,0,0,1,1h6l1.967-.786a3,3,0,0,1,1.111-.214H19.79l1.062-1.065a1,1,0,0,0,.243-1.023l-.175-.521a1,1,0,0,1,.055-.763Z"
        fill="#c4f0eb"
      />
      <path
        d="M20.921,19.891a.807.807,0,0,1-.014-.11c-8.23.8-14.712-.906-9.72-10.877l-.351.235a2.979,2.979,0,0,0-.888.921l-3.3,5.361a2,2,0,0,1-1,.821L2.29,17.5v5a1,1,0,0,0,1,1h6l1.967-.786a3,3,0,0,1,1.111-.214H19.79l1.063-1.065a1,1,0,0,0,.242-1.023Z"
        fill="#c4f0eb"
      />
      <path
        d="M12.59,12.5,10.873,1.16a.6.6,0,0,1,.6-.66h8.24a.6.6,0,0,1,.593.689L18.607,12.5Z"
        fill="#c4f0eb"
      />
      <path
        d="M12.289,10.5,10.875,1.074A.5.5,0,0,1,11.37.5h6.919"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.789,12.5l-.945-9.45a.5.5,0,0,1,.5-.55h6.867a.5.5,0,0,1,.494.574L20.289,12.5"
        fill="#00e6ca"
      />
      <path
        d="M12.29,12.5h8.5l.63.945a1,1,0,0,1,0,1.11l-.308.462a1,1,0,0,0-.062,1l.517,1.034a1,1,0,0,1,0,.894l-.592,1.183a1,1,0,0,0-.054.763l.174.521a1,1,0,0,1-.242,1.023L19.79,22.5H12.368a2.992,2.992,0,0,0-1.114.215L9.29,23.5"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.29,17.5l3.358-1.259a2,2,0,0,0,1-.825l3.3-5.357a3.007,3.007,0,0,1,.891-.923l1.135-.757"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M21.211,2.5H14.344a.5.5,0,0,0-.5.55l.666,6.659,7.054-7.054A.5.5,0,0,0,21.211,2.5Z"
        fill="#c4f0eb"
      />
      <path
        d="M14.789,12.5l-.945-9.45a.5.5,0,0,1,.5-.55h6.867a.5.5,0,0,1,.494.574L20.289,12.5"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.54,9a1.25,1.25,0,1,0-1.25-1.25A1.25,1.25,0,0,0,17.54,9Z"
        fill="#f8fafc"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
